// eslint-disable-next-line import/prefer-default-export
export const ORGANIZATIONS_SELECTOR_AVAILABLE_PATHS = [
  '/patients-page',
  '/subscriptions',
  '/locations'
];
